import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
const testimonials = [{
  initials: 'CR',
  text: 'El Módulo 3 fue el más importante para mí. Nunca nadie me había explicado tan claramente por qué reaccionaba como reaccionaba ante ciertas personas. Lo leí subrayando cada página.',
  name: 'Cecilia R.',
  city: 'Mendoza'
}, {
  initials: 'SC',
  text: 'Soy de las que empieza y abandona. Pero el ebook es tan práctico que terminé los 6 módulos en una semana. Las frases del Bonus 1 las uso todos los días.',
  name: 'Sofía C.',
  city: 'La Plata'
}, {
  initials: 'PA',
  text: 'El bonus de detectar manipuladores me abrió los ojos. Identifiqué patrones en mi familia que llevaba años sin ver. Ahora respondo de otra manera y todo cambió.',
  name: 'Paula A.',
  city: 'Neuquén'
}, {
  initials: 'JM',
  text: 'El Módulo 5 sobre proteger tu energía mental fue clave. Llevaba meses agotada y no sabía por qué. Empecé a aplicar las técnicas y en dos semanas algo se movió.',
  name: 'Julia M.',
  city: 'Rosario'
}, {
  initials: 'MV',
  text: 'Compré el ebook y los bonus. El de jefes difíciles fue lo mejor. Tengo una jefa muy complicada y antes salía agotada del trabajo. Ahora salgo entera.',
  name: 'María V.',
  city: 'Tucumán'
}, {
  initials: 'GR',
  text: 'Lo que más me impactó fue el Módulo 6 con casos reales. Cada caso era similar al mío. Ver las soluciones aplicadas me dio claridad para mi propia situación.',
  name: 'Gabriela R.',
  city: 'Santa Fe'
}];
export function TestimonialsSection() {
  return <section className="w-full bg-bg-warm py-20 md:py-28 px-4" data-id="element-347" data-mp="2m2h8pk873uh9">
      <div className="max-w-6xl mx-auto" data-id="element-348" data-mp="2h19wn8z0s94s">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-349" data-mp="2h0i281h5shg3">
          <div className="inline-flex items-center gap-2 bg-rose-bg text-rose px-4 py-1.5 rounded-full mb-6" data-id="element-350" data-mp="8dc4pwbrg9ep">
            <span className="text-xs font-bold tracking-widest" data-id="element-351" data-mp="dcosqkedbmiv">
              ❤️ MÁS LECTORES QUE YA LO TIENEN
            </span>
          </div>
          <h2 className="font-serif font-bold text-3xl sm:text-4xl md:text-5xl text-ink leading-[1.1] uppercase tracking-tight" data-id="element-352" data-mp="i9yosiw9iwfo">
            Personas que ya empezaron a recuperar su{' '}
            <span className="font-serif-italic text-rose font-normal normal-case" data-id="element-353" data-mp="3lt1g9kwta1z6">
              tranquilidad
            </span>
          </h2>
          <div className="flex flex-col items-center gap-2 mt-6" data-id="element-354" data-mp="3vib9x57azspe">
            <div className="flex gap-1" data-id="element-355" data-mp="3vko0u7v1hdel">
              {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-rose text-rose" data-id="element-356" data-mp="2y2xdtgvd089r" data-mpi={i} />)}
            </div>
            <div className="text-sm text-ink-soft" data-id="element-357" data-mp="3305ute4ru69f">
              <strong data-id="element-358" data-mp="1k7fgcgeugr06">4.8/5</strong> · basado en{' '}
              <strong className="text-rose" data-id="element-359" data-mp="1k4tdgu2wezoa">+2.000</strong> opiniones
            </div>
          </div>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5" data-id="element-360" data-mp="1b67nidv3kidh">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.06,
          duration: 0.5
        }} className="bg-white border border-line rounded-3xl p-6 shadow-sm" data-id="element-361" data-mp="167wchzt2g1to" data-mpi={i}>
              <div className="flex items-center gap-3 mb-4" data-id="element-362" data-mp="ii217moealbj">
                <div className="w-11 h-11 rounded-full bg-rose text-white flex items-center justify-center font-bold font-serif text-sm" data-id="element-363" data-mp="diped1xixe8y">
                  {t.initials}
                </div>
                <div className="flex gap-0.5" data-id="element-364" data-mp="2dnb54zehdl3d">
                  {[...Array(5)].map((_, j) => <StarIcon key={j} className="w-4 h-4 fill-rose text-rose" data-id="element-365" data-mp="2ilw6j25gyate" data-mpi={j} />)}
                </div>
              </div>
              <p className="font-serif-italic text-ink leading-relaxed mb-4" data-id="element-366" data-mp="28tgoy5y33o91">
                "{t.text}"
              </p>
              <div className="text-sm font-semibold text-ink pt-4 border-t border-line" data-id="element-367" data-mp="1uto2wnxi5w7e">
                {t.name}{' '}
                <span className="text-muted font-normal" data-id="element-368" data-mp="1zuv609opa77q">— {t.city}</span>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}